import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { MenuItem } from 'primereact/menuitem';
import { getAction } from '../../../appconfig/AppHelper';

export const OtherApplicationTab = (initialTabLabel: any) => {
    const router = useNavigate();
    const [actions, setActions] = useState<any>([]);
    const [activeIndex, setActiveIndex] = useState<number>(0);

    const HRitems: MenuItem[] = [
        {
            label: 'Address Change',
            command: () => {
                router('/app/application/address-change');
            }
        },
        {
            label: 'Name Change',
            command: () => {
                router('/app/application/name-change');
            }
        },
        {
            label: 'Good Standing Application',
            command: () => {
                router('/app/application/goodstanding-application-list');
            }
        },
        {
            label: 'Duplicate Cert.',
            command: () => {
                router('/app/application/duplicate-certificate-application-list');
            }
        },
        {
            label: 'Reg Cancel',
            command: () => {
                router('/app/application/registration-cancellation');
            }
        },
        {
            label: 'Degree Additional',
            command: () => {
                router('/app/application/degree-addition');
            }
        },
        {
            label: 'Pro To Org',
            command: () => {
                router('/app/application/pro-to-org-application');
            }
        },
        {
            label: 'Penalty',
            command: () => {
                router('/app/application/penlty');
            }
        },
        {
            label: 'Penalty Under Jan Vishwas',
            command: () => {
                router('/app/application/penalty-jan-vishwas');
            }
        },
        {
            label: 'Search',
            command: () => {
                router('/app/application/search');
            }
        }
    ];

    const filteredHRitems = HRitems.filter((item) => item.label && Object.prototype.hasOwnProperty.call(actions, item.label));

    // use Effect method
    useEffect(() => {
        setActions(getAction('Other Application'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        if (filteredHRitems.length > 0 && initialTabLabel) {
            const foundIndex = filteredHRitems.findIndex((item) => item.label == initialTabLabel.initialTabLabel);
            setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
        }
    }, [actions, filteredHRitems]);

    return (
        <>
            <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab inner-tab" />
        </>
    );
};

// import { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { TabMenu } from 'primereact/tabmenu';
// import { MenuItem } from 'primereact/menuitem';
// import { getAction } from '../../../appconfig/AppHelper';

// export const OtherApplicationTab = ({ initialTabLabel }: { initialTabLabel: string }) => {
//     const router = useNavigate();
//     const [actions, setActions] = useState<any>({});
//     const [activeIndex, setActiveIndex] = useState<number>(0);

//     // Define full list with paths, no command yet
//     const allItems: { label: string; path: string }[] = [
//         { label: 'Address Change', path: '/app/application/address-change' },
//         { label: 'Name Change', path: '/app/application/name-change' },
//         { label: 'Good Standing Application', path: '/app/application/goodstanding-application-list' },
//         { label: 'Duplicate Cert.', path: '/app/application/duplicate-certificate-application-list' },
//         { label: 'Reg Cancel', path: '/app/application/registration-cancellation' },
//         { label: 'Degree Additional', path: '/app/application/degree-addition' },
//         { label: 'Pro To Org', path: '/app/application/pro-to-org-application' },
//         { label: 'Penalty', path: '/app/application/penlty' },
//         { label: 'Search', path: '/app/application/search' }
//     ];

//     // Filter items based on actions (permissions)
//     const filteredHRitems: MenuItem[] = allItems
//         .filter((item) => Object.prototype.hasOwnProperty.call(actions, item.label))
//         .map((item) => ({
//             label: item.label,
//             command: () => router(item.path)
//         }));

//     // Load permitted actions on mount
//     useEffect(() => {
//         const fetchedActions = getAction('Other Application');
//         setActions(fetchedActions);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     }, []);

//     // Set the active tab based on initialTabLabel
//     useEffect(() => {
//         if (filteredHRitems.length > 0 && initialTabLabel) {
//             const foundIndex = filteredHRitems.findIndex((item) => item.label === initialTabLabel);
//             setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
//         }
//     }, [actions, filteredHRitems]);

//     return <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab inner-tab" />;
// };
